import { 
    DIFFUSION_BEGIN,
    DIFFUSION_ADD,
    DIFFUSION_FAILURE,
} from 'app/actions/DiffusionActions';

const initialState = {
	byId: {},
	allIds: [],
	isLoading: false,
};

export default function DiffusionReducer (state = initialState, action) {
	switch (action.type) {
        case DIFFUSION_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case DIFFUSION_ADD: 
			let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
			};
        case DIFFUSION_FAILURE: 
			return {
				...state,
				isLoading: false
			}
		default:
			return state;
	}
};

export const getDiffusion = state => {
	return state.allIds.map( id => state.byId[id] );
}

export const getIsLoadingDiffusion = state => {
    return state.isLoading;
}